import styled from 'styled-components'
import { TextButton } from '@shipt/design-system-buttons'
import { type ProductCardProduct } from '@/features/shop/components/ProductCard/types'
import { SkeletonConsumer } from '@/features/shared/components/SkeletonLoader'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicMoreLikeThisItemsDrawer } from '@/features/shop/components/Drawer/MoreLikeThisItemsDrawer/DynamicMoreLikeThisItemsDrawer'

type Props = { product: ProductCardProduct; className?: string }

export const ProductCardSeeSimilarButton = ({ product, className }: Props) => {
  const { openDialog } = useHandleDialog()

  const handleOpenMoreLikeThisItemsModal = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    openDialog(DynamicMoreLikeThisItemsDrawer, { product })
  }

  return (
    <SimilarButton size="md" onClick={handleOpenMoreLikeThisItemsModal} className={className}>
      <SkeletonConsumer width={85} height={20}>
        See similar
      </SkeletonConsumer>
    </SimilarButton>
  )
}

const SimilarButton = styled(TextButton)`
  justify-content: flex-start;
`
